import type { MarketplaceBuyDirectStatus } from '__generated__/zeus/types';
import type { MarketplaceProperty } from 'components/marketplace/property/types';

type BuyDirectEligibilityInput = Pick<MarketplaceProperty, 'buyDirectStatus'>;

const buyDirectEligibility = {
  AVAILABLE: true,
  BACKUP_OFFER: true,
  IN_CONTRACT: true,
  OFFER_DEADLINE: true,
} satisfies Record<MarketplaceBuyDirectStatus, boolean>;

export const isBuyDirectEligible = (property: BuyDirectEligibilityInput): boolean =>
  property.buyDirectStatus !== null && buyDirectEligibility[property.buyDirectStatus] === true;
